import React, { FC, memo } from "react";
import { Typography } from "@material-ui/core";

type SubTDProps = {
  submissionTypes: string[];
};

const SubTD: FC<SubTDProps> = memo(({ submissionTypes }) => {
  return (
    <>
      {submissionTypes.map((sub, idx) => (
        <Typography variant="body2" key={sub + idx}>
          {sub}
        </Typography>
      ))}
    </>
  );
});

export default SubTD;
